<div class="container-fluid">
    <div class="row">
        <div class="col-6 question-text">
            <u>{{question.questionText}}</u>
        </div>
        <div class="offset-6"></div>
    </div>
</div>
